<template>
  <!--  去除前端30分钟失效重新登录-->
  <!--  <div id="app" @click="isDo()" @mousemove="isDo()">-->
  <div id="app">
    <LutticaScrollBar width="100%" height="100%">
      <!-- <keep-alive>
        <router-view />
      </keep-alive> -->
      <router-view />
    </LutticaScrollBar>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import { baseRouterList } from '@/config/router.config';

export default {
  data() {
    const baseRouterPathList = baseRouterList.map(item => item.path);
    return {
      lastTime: new Date().getTime(), // 最后一次点击的时间
      isInTimer: false,
      timeOut: 30 * 60 * 1000, // 设置超时时间： 30分钟
      baseRouterPathList,
    };
  },
  computed: {},
  created() {
    // this.lastTime = new Date().getTime(); // 网页第一次打开时，记录当前时间
    // console.log('this.lastTime', new Date(this.lastTime))
    // 删除loading动画
    document.body.removeChild(document.getElementById('appLoading'));
    document.body.style.backgroundColor = '#fff';
    setTimeout(() => {
      document.getElementById('app').style.display = 'block';
    }, 500);
    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      this.updateState({
        contentHeight: document.documentElement.clientHeight - 172,
        contentWidth: document.documentElement.clientWidth - 110,
      });
    });
  },
  watch: {
    $route(route, from) {
      const name = route.name;

      if (route.meta.id === '/employee-information' && from.params.empId && from.params.empName) {
        route.params.empId = from.params.empId;
        route.params.empName = from.params.empName;
      }
      // this.lastTime = new Date().getTime();
      // console.log(new Date(this.lastTime), 'this.lastTimeroute')
      if (
        [
          'orgStructure',
          'orgRelationShip',
          'organization',
          'staff',
          'myAgent',
          'myNeeds',
          'entry',
          'periodicSalary',
          'nonPeriodicSalary',
          'status',
          'workloadSalary',
          'staffSalary',
          'timeEvaluation',
          'quotaIssuance',
        ].includes(name)
      )
        this.bindZzClick(true);
      else this.bindZzClick(false);
    },
  },
  methods: {
    isDo() {
      if (!this.isInTimer) {
        const currentPath = this.$router.history.current.path;
        if (this.baseRouterPathList.indexOf(currentPath) === -1) {
          const currentTime = new Date().getTime(); // 记录这次点击的时间
          // 是否超过过期时间限制
          if (currentTime - this.lastTime > this.timeOut) {
            this.lastTime = currentTime;
            this.$store.dispatch('user/logout');
          }
          this.lastTime = currentTime;
        }
        this.isInTimer = true;
        setTimeout(() => {
          this.isInTimer = false;
        }, 60 * 1000);
      }
    },
    // 点击任何地方取消组织弹框
    bindZzClick(flag) {
      const wrapper = document.getElementById('app');
      if (flag) wrapper.addEventListener('click', this.handleClick, true);
      else wrapper.removeEventListener('click', this.handleClick, true);
    },
    handleClick(e) {
      const pathR = e.path || (e.composedPath && e.composedPath());
      const index = pathR.findIndex(item => item.className === 'org-tree-node-label');
      if (index === -1) {
        const poptips = document.querySelectorAll('.ivu-poptip-popper');
        for (let i = 0; i < poptips.length; i += 1) {
          const flag = poptips[i].__vue__.$vnode.context.visible;
          if (flag) poptips[i].__vue__.$vnode.context.visible = false;
        }
      }
    },
    ...mapMutations(['updateState']),
  },
};
</script>
<style lang="less">
@import './theme/appless.less';
</style>
